import { useState } from 'react';
import {
  ArrayLayoutProps,
  composePaths,
  createDefaultValue,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import { withJsonFormsArrayLayoutProps } from '@jsonforms/react';
import { ArrayWrapper } from './ArrayWrapper';
import './style.scss';
import { Button } from '../../../../../elements/Button';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import remove from 'lodash/remove';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import isEqual from 'lodash/isEqual';
import { cloneDeep } from 'lodash';
const ArrayLayoutRenderer = ({
  visible,
  enabled,
  uischema,
  schema,
  label,
  renderers,
  cells,
  data,
  path,
  minItems,
  addItem,
  removeItems,
}: ArrayLayoutProps) => {
  const { handleFieldChange, formData } = useDynamicFormContext();
  const [arrayItemsCount, setArrayItemsCount] = useState(data || minItems || 1);
  const removeBtnText = uischema?.options?.removeBtnText || 'Remove';
  const maxItems = uischema?.options?.maxItems;
  const containerClass = uischema?.options?.containerClass || '';
  const itemClass = uischema?.options?.itemClass || '';
  const viewOnly = uischema?.options?.viewOnly;
  const reorderArray = (path: string, itemToRemove: any) => {
    const data = cloneDeep(formData);
    const newData = remove(data[path], function (n: any) {
      return (
        !isUndefined(n) && !isNull(n) && !isEqual(n, data[path][itemToRemove])
      );
    });
    return newData
  };
  const addItemCb = (p: string, value: any) => {
    setArrayItemsCount(arrayItemsCount + 1);
    return addItem(p, value);
  };
  const removeItemsCb = (path: string, toDelete: number[]) => {
    setArrayItemsCount(arrayItemsCount - 1);
    if (toDelete && removeItems) {
      handleFieldChange(composePaths(path, toDelete[0].toString()), null);
      removeItems(path, toDelete);
      handleFieldChange(path, reorderArray(path, toDelete[0].toString()));
    }
  };
  const toRender = Array(
    enabled ? (arrayItemsCount ? arrayItemsCount : data) : data,
  )
    .fill(0)
    .map((_, i) => {
      return (
        <div className={`tru-aray-wrapper ${itemClass} `}>
          <ArrayWrapper
            index={i}
            schema={schema}
            uischema={uischema}
            path={composePaths(path, `${i}`)}
            renderers={renderers}
            cells={cells}
            label={(label as string) + ` ${i + 1}`}
            direction={'column'}
            enabled={enabled}
            visible={visible}
            disabled={!enabled}
          />{' '}
          {!viewOnly && (
            <Button
              classes="tru-array-remove-button"
              disabled={!enabled || i === 0}
              onClick={() => removeItemsCb(path, [i])}
              type="link"
            >
              {removeBtnText}
            </Button>
          )}
        </div>
      );
    });
  return (
    <div
      className={`tru-layout-Section tru-dynamic-form-wrapper tru-sub-section-header tru-array-layout ${containerClass}`}
    >
      {toRender}
      {!viewOnly && (
        <div className="tru-array-add-button-container">
          <Button
            classes="tru-array-add-button"
            type="outlined"
            onClick={() => addItemCb(path, createDefaultValue(schema))}
            disabled={!enabled || maxItems === arrayItemsCount}
          >
            + {label as string}
          </Button>
        </div>
      )}
    </div>
  );
};

export const ArrayDynamicFormLayout = {
  tester: rankWith(1, uiTypeIs('ArrayDynamicFormLayout')),
  renderer: withJsonFormsArrayLayoutProps(ArrayLayoutRenderer),
};
